import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { Tenant } from '@/lib/types';

/** 套用租戶白牌主色到 CSS 變數（登入後）。 */
export function useTenantTheme(enabled: boolean): Tenant | undefined {
  const tenant = useQuery({
    queryKey: ['tenant'],
    enabled,
    queryFn: () => api.get<Tenant>('/tenant'),
  });

  useEffect(() => {
    const t = tenant.data;
    if (!t) return;
    const root = document.documentElement;
    root.style.setProperty('--primary', t.color);
    root.style.setProperty('--primary-soft', t.colorSoft);
    root.style.setProperty('--primary-tint', t.colorTint);
  }, [tenant.data]);

  return tenant.data;
}
